// extracted by mini-css-extract-plugin
export default {"shop-content":"DYLsBxMhx1ISrP5B3XbF","shop-name":"Ze4jyZxcGRz9NbIPn_i4","shop-info":"t9ibjdkVKBQZikpgzZFw","shop-info-content":"kop8eNMIpnwIvehuKNXS"};